import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import cns from 'classnames';
import styles from './pagebanner.module.scss';

/**
 *@example
 *    <PageBanner
        title="Our Events"
        subtitle="Sed ultrices nisl velit, eu ornare est ."
        description="Nam ullamcorper rhoncus sem vitae tempus."
      />
 *
 * @export
 * @param {*} { title, subtitle, description }
 * @return {*} 
 */
export default function PageBanner({ title, subtitle, description }) {
  return (
    <div className={cns(styles.bannerWrapper, 'py-5')}>
      <Container>
        <Row className="py-5">
          <Col md={9}>
            <div className="py-md-5">
              <h1 className="pt-5">{title}</h1>
              {!!subtitle && <h5 className="font-s1 my-md-3">{subtitle}</h5>}
              {!!description && (
                <p className="font-s1 pb-md-5">{description}</p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
